module.exports = __webpack_public_path__ + "img/has_standard.8f3e8c0e.png";